import { UiColors } from "../../../../config/ui/colors";

export const COLLECTION_OF_WEEE_BY_EU_MEMBER_STATES_CHART_DATA_KEYS = [
	{
		name: "large",
		translation: "Large home appliances",
		color: UiColors.charts.primary,
	},
	{
		name: "small",
		translation: "Small home appliances",
		color: UiColors.charts.secondary,
	},
	{
		name: "other",
		translation: "Other",
		color: UiColors.charts.grid,
	},
];